<template>
  <b-sidebar id="sidebar-1" title="Ενέργειες εφαρμογής" backdrop right shadow>
    <div class="px-3 py-2">
      <b>
        <ul class="navbar-nav  mr-auto">
          <UserTitle />
          <br>
          <LogoutButton />
          <hr>
          <NavLinksGuest select="Αρχική Σελίδα" :isSidebar="true"/>
          <UserKanonismoiMenu
              v-if="isUser && kanonismoiAccess"
          />
          <UserMenu
              v-else-if="isUser"
          />
          <AdminMenu v-if="isAdmin" />
          <SuperAdminMenu v-if="isSuperAdmin" />
          <ManagerMenu v-if="isManager" />
          <SxhmatismosMenu v-if="isSxhmatismos" />
<!--          <UserKanonismoiMenu v-if="kanonismoiAccess"/>-->
          <NavLinksGuest exclude="Αρχική Σελίδα" :isSidebar="true"/>
        </ul>
      </b>
    </div>
  </b-sidebar>
</template>

<script>
import LogoutButton from "@/components/navigation/menu/utils/LogoutButton";
import UserMenu from "@/components/navigation/menu/user/UserMenu";
import AdminMenu from "@/components/navigation/menu/admin/AdminMenu";
import UserTitle from "@/components/navigation/menu/utils/UserTitle";
import ManagerMenu from "@/components/navigation/menu/manager/ManagerMenu";
import SxhmatismosMenu from "@/components/navigation/menu/sxhmatismos/SxhmatismosMenu";
import NavLinksGuest from "@/components/navigation/NavLinksGuest";
import SuperAdminMenu from "@/components/navigation/menu/super_admin/SuperAdminMenu";
import UserKanonismoiMenu from "@/components/navigation/menu/user/UserKanonismoiMenu.vue";

export default {
  name: "Sidebar",
  components: {SuperAdminMenu, ManagerMenu, UserMenu, AdminMenu, UserTitle, LogoutButton, SxhmatismosMenu, NavLinksGuest, UserKanonismoiMenu},
  computed: {
    role: function() {
      return this.$store.getters.userRole;
    },
    username: function() {
      if (this.$store.getters.user.onoma) {
        return this.$store.getters.user.onoma + ' ' + this.$store.getters.user.epitheto
      }
      return null
    },
    kanonismoiAccess: function() {
      return this.$store.getters.user.kanonismoiAccess;
    },
    isUser: function () {
      return this.role === 'ROLE_USER'
    },
    isAdmin: function () {
      return this.role === 'ROLE_ADMIN'
    },
    isSuperAdmin: function () {
      return this.role === 'ROLE_SUPERADMIN'
    },
    isManager: function () {
      return this.role === 'ROLE_MANAGER'
    },
    isSxhmatismos: function () {
      return this.role === 'ROLE_SXHMATISMOS'
    }
  },
}
</script>

<style scoped>

.navbar-nav {
  flex-direction: column !important;
}
.navbar-nav li a,
>>> .user-menu li a,
>>> .admin-menu li a,
>>> .sxhmatismos-menu li a,
>>> .manager-menu li a,
>>> .user-title li a,
>>> .user-title div {
  color: #007bff !important;
}

.navbar-nav li a:hover,
>>> .user-menu li a:hover,
>>> .admin-menu li a:hover,
>>> .sxhmatismos-menu li a:hover,
>>> .manager-menu li a:hover,
>>> .user-title li a:hover{
  color: #0072C6 !important;
}
</style>